import script from "./list-translate.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-translate.vue?vue&type=script&setup=true&lang=ts"

import "./list-translate.vue?vue&type=style&index=0&id=459e721f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459e721f"]])

export default __exports__